import React from "react";
import { CreditCard, Banknote, History, Check } from "lucide-react";
import { useUserTheme } from "src/shared/hooks/useUserTheme";

interface PaymentMethodsProps {
  paylate: boolean;
  cashpay: boolean;
  paycard: boolean;
  setpaylate: React.Dispatch<React.SetStateAction<boolean>>;
  setcashpay: React.Dispatch<React.SetStateAction<boolean>>;
  setpaycard: React.Dispatch<React.SetStateAction<boolean>>;
}

const PaymentMethods: React.FC<PaymentMethodsProps> = ({ paylate, cashpay, paycard, setpaylate, setcashpay, setpaycard }) => {
  const { bgClass } = useUserTheme();

  const methods = [
    {
      key: "paylate",
      label: "Buy on Credit",
      icon: History,
      active: paylate,
      description: "Pay later",
      onClick: () => {
        setpaylate(true);
        setcashpay(false);
        setpaycard(false);
      },
    },
    {
      key: "paycard",
      label: "Card",
      icon: CreditCard,
      active: paycard,
      description: "Debit / Credit",
      onClick: () => {
        setpaycard(true);
        setpaylate(false);
        setcashpay(false);
      },
    },
    {
      key: "cashpay",
      label: "Cash",
      icon: Banknote,
      active: cashpay,
      description: "Pay now",
      onClick: () => {
        setcashpay(true);
        setpaylate(false);
        setpaycard(false);
      },
    },
  ];

  return (
    <div className="w-full grid grid-cols-3 gap-2 p-1">
      {methods.map((method) => {
        const Icon = method.icon;

        return (
          <div
            key={method.key}
            onClick={method.onClick}
            className={`relative cursor-pointer rounded-xl border p-2 transition-all duration-150
              ${method.active ? `${bgClass} text-white border-transparent shadow-sm` : "border-gray-200 bg-white hover:border-indigo-300"}`}
          >
            {/* Tick */}
            {method.active && (
              <div className="absolute top-1 right-1 w-4 h-4 flex items-center justify-center rounded-full bg-white/30">
                <Check size={10} />
              </div>
            )}

            <div className="flex items-center gap-2">
              {/* Icon */}
              <div
                className={`w-8 h-8 flex items-center justify-center rounded-full
                  ${method.active ? "bg-white/20 text-white" : "bg-gray-100 text-gray-600"}`}
              >
                <Icon size={16} />
              </div>

              {/* Text */}
              <div className="flex flex-col leading-tight">
                <span className={`text-xs font-semibold ${method.active ? "text-white" : "text-gray-800"}`}>{method.label}</span>

                <span className={`text-[10px] ${method.active ? "text-white/80" : "text-gray-500"}`}>{method.description}</span>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default PaymentMethods;
